import { Col, Grid, Group, Table, Text } from '@mantine/core';
import { formatNumberWithCommasAndDecimals } from '../../helpers/common.helpers';
import { TransactionStats } from '../../type/retrieve-transaction.types';

interface Props {
  transactionStats: TransactionStats | undefined;
}
function TransactionStatistics(props: Props) {
  const { transactionStats } = props;
  const PhpValue = (props: {
    label: string;
    value?: number;
    isBold?: boolean;
  }) => {
    const { label, value, isBold } = props;
    return (
      <tr>
        <td style={{ backgroundColor: '#F6F8FB' }}>
          <Text weight={600} align='right' size='sm'>
            {label}
          </Text>
        </td>
        <td
          style={{
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <Text
            size='sm'
            style={{ marginRight: 10 }}
            weight={isBold ? 600 : 'normal'}
          >
            PHP
          </Text>
          <Text size='sm' weight={isBold ? 600 : 'normal'}>
            {formatNumberWithCommasAndDecimals(value ?? 0)}
          </Text>
        </td>
      </tr>
    );
  };

  const UsdValue = (props: {
    label: string;
    value?: number;
    isBold?: boolean;
  }) => {
    const { label, value, isBold } = props;
    return (
      <tr>
        <td style={{ backgroundColor: '#F6F8FB' }}>
          <Text weight={600} align='right' size='sm'>
            {label}
          </Text>
        </td>
        <td
          style={{
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <Text
            size='sm'
            style={{ marginRight: 10 }}
            weight={isBold ? 600 : 'normal'}
          >
            USD
          </Text>
          <Text size='sm' weight={isBold ? 600 : 'normal'}>
            {formatNumberWithCommasAndDecimals(value ?? 0)}
          </Text>
        </td>
      </tr>
    );
  };

  return (
    <>
      <Group p='md' style={{ maxWidth: 700 }}>
        <Grid
          style={{
            width: '100%',
          }}
        >
          <Col
            sm={6}
            span={12}
            style={{
              overflow: 'auto',
            }}
          >
            <Table
              style={{
                textAlign: 'right',
              }}
            >
              <tbody>
                <PhpValue
                  label='PURCHASED'
                  value={transactionStats?.totals.php.purchased}
                />
                <PhpValue
                  label='PENDING'
                  value={transactionStats?.totals.php.pending}
                />
                <PhpValue
                  label='REFUND'
                  value={transactionStats?.totals.php.refund}
                />
                <PhpValue
                  label='DECLINED'
                  value={transactionStats?.totals.php.declined}
                />
                <PhpValue
                  label='CANCELLED'
                  value={transactionStats?.totals.php.cancelled}
                />
                <PhpValue
                  label='TOTAL'
                  value={transactionStats?.totals.php.total}
                  isBold={true}
                />
              </tbody>
            </Table>
          </Col>
          <Col
            sm={6}
            span={12}
            style={{
              overflow: 'auto',
            }}
          >
            <Table
              style={{
                textAlign: 'right',
              }}
            >
              <tbody>
                <UsdValue
                  label='PURCHASED'
                  value={transactionStats?.totals.usd.purchased}
                />
                <UsdValue
                  label='PENDING'
                  value={transactionStats?.totals.usd.pending}
                />
                <UsdValue
                  label='REFUND'
                  value={transactionStats?.totals.usd.refund}
                />
                <UsdValue
                  label='DECLINED'
                  value={transactionStats?.totals.usd.declined}
                />
                <UsdValue
                  label='CANCELLED'
                  value={transactionStats?.totals.usd.cancelled}
                />
                <UsdValue
                  label='TOTAL'
                  value={transactionStats?.totals.usd.total}
                  isBold={true}
                />
              </tbody>
            </Table>
          </Col>
        </Grid>
      </Group>
    </>
  );
}

export default TransactionStatistics;
